<template>
  <nav class="cx-option">
    <a class="cx-option__item"
      v-for="(section, index) in Object.keys(data)" :key="section"
      :class="{'-active': index == active}"
      @click="$emit('sectionChanged', index)"
    >{{section}}</a>
  </nav>
</template>

<script>
export default {
  name: 'accessibility-subcategories',
  props: ['data', 'active'],
};
</script>
